import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { Box, Button, Stack } from "@mui/material";
import { SearchAutocomplete } from "./searchAutocomplete";
import { ModifiedTextField } from "./textField";
import RadioField from "./radioField";
import Grid from "@mui/material/Unstable_Grid2";
import { useStoreState, useStoreActions } from "easy-peasy";
import RecycledResinDialog from "./recycledResinDialog";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import VirginResinDialog from "./virginResinDialog";
import { resinAPI, customerAPI } from "../../apis/index";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Select, MenuItem, FormHelperText } from "@mui/material";
import {
  RESIN_CLASS,
  DEFAULT_RESIN_CLASS_PO,
  RESIN_CLASS_SUB_CLASS_MAPPING,
} from "../../utils/constant";
import Loader from "./../evaluationResults/loader";
import MaskedTextField from "./../common/MaskedTextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
const paddingZero = { paddingTop: 0, paddingLeft: "8px" };

//  This component is primary handling the
//  - SalesORG and customer API
//  - Pop up (RecycleResin and VirginResin) open close logic
export const CustomerRequirements = () => {
  let newFormErrors = useStoreState((state) => state.newFormErrors);
  const setNewFormErrors = useStoreActions(
    (actions) => actions.setNewFormErrors
  );

  let requirements = useStoreState((state) => state.requirements);

  let setRequirements = useStoreActions((actions) => actions.setRequirements);

  let virginDialogErrors = useStoreState((state) => state.virginDialogErrors);
  let setVirginDialogErrors = useStoreActions(
    (actions) => actions.setVirginDialogErrors
  );

  let recycledDialogErrors = useStoreState(
    (state) => state.recycledDialogErrors
  );

  let setRecycledDialogErrors = useStoreActions(
    (actions) => actions.setRecycledDialogErrors
  );

  const setNextBtnDisabled = useStoreActions(
    (actions) => actions.setNextBtnDisabled
  );

  const [selectedOption, setSelectedOption] = useState("tar");

  const [selectedVirginResin, setSelectedVirginResin] = useState(
    "Characterized Resin"
  );

  const [mask, setMask] = useState("999999-99"); // Default phone mask

  const [openRecycleResin, setOpenRecyleResin] = useState(false);
  const [openVirginResin, setOpenVirginResin] = useState(false);

  const [salesOrg, setSalesOrg] = useState(null);
  const [customer, setCustomer] = useState(null);

  let [selectedResinValue, setSelectedResinValue] = useState(
    DEFAULT_RESIN_CLASS_PO
  );
  const [loading, setLoading] = useState(false);

  const [virginCharacterizedResinOptions, setVirginCharacterizedResinOptions] =
    useState([]);
  let [recycleCharacterizedResinOptions, setRecycleCharacterizedResinOptions] =
    useState([]);

  let [
    recycledCharchterizedResinResponse,
    setRecycledCharchterizedResinResponse,
  ] = useState([]);
  let [
    virginCharachterizedResinResponse,
    setVirginCharachterizedResinResponse,
  ] = useState([]);

  const [recycleCharacterizedResin, setRecycleCharacterizedResin] =
    useState("");
  const [virginCharacterizedResin, setVirginCharacterizedResin] = useState("");

  // when click on upload file button it will display the pop up
  const handleClickOpenRecycleResin = () => {
    setOpenRecyleResin(true);
  };

  // when click on upload file button it will display the pop up
  const handleClickOpenVirginResin = () => {
    setOpenVirginResin(true);
  };

  const handleSelectedResinClass = (event) => {
    // change the main form state for enable and disable the button
    setNewFormErrors(() => {
      // This `prevErrors` is the latest state from the store
      return {
        ...newFormErrors,
        recycled: {
          required: true,
          highlight: false,
        },
        virgin: {
          required: true,
          highlight: false,
        },
      };
    });

    setSelectedResinValue(event.target.value);
    setRequirements({ ...requirements, resinClass: event.target.value });

    setRecycleCharacterizedResinOptions(
      recycledCharchterizedResinResponse?.filter((element) => {
        if (requirements?.resinClass == DEFAULT_RESIN_CLASS_PO) {
          return element.sub_class.includes("PET");
        } else {
          return !element.sub_class.includes("PET");
        }
      })
    );
    setVirginCharacterizedResinOptions(
      virginCharachterizedResinResponse?.filter((element) => {
        if (requirements?.resinClass == DEFAULT_RESIN_CLASS_PO) {
          return element.sub_class.includes("PET");
        } else {
          return !element.sub_class.includes("PET");
        }
      })
    );
    setRecycleCharacterizedResin("");
    setVirginCharacterizedResin("");
  };

  useEffect(() => {
    // Simulate a radio button selection on component mount/reload
    // if (selectedOption) {
    //   setSelectedOption(requirements?.requestType); // Set the state
    //   /*
    //     create a fake event object that mimics the event object that the radio button onChange event would normally create.
    //   */
    //   const fakeEvent = {
    //     target: {
    //       value: requirements?.requestType,
    //     },
    //   };
    //   handleRadioChange(fakeEvent); // Manually trigger the handler
    // } else {
    // }
  }, []);

  //  handling the number input and validation
  const inputChange = (event, maxValue) => {
    let input = event.target.value;
    let name = event.target.name;
    // Prevent exceeding number of digits or decimal points
    setRequirements({
      ...requirements,
      [name]: input,
    });

    /* Function to enable the red border of validation field */
    const errorMessage = validateField(name, input);

    let obj = {};
    if (errorMessage == "") {
      obj = {
        required: false,
        highlight: false,
      };
    } else {
      obj = {
        required: true,
        highlight: true,
      };
    }

    setNewFormErrors(() => {
      // This `prevErrors` is the latest state from the store
      return {
        ...newFormErrors,
        [name]: obj,
      };
    });
  };

  useEffect(() => {}, [requirements]);

  const inputTextChange = (event) => {
    let input = event.target.value;
    let name = event.target.name;
    // Prevent exceeding number of digits or decimal points
    setRequirements({
      ...requirements,
      [name]: input,
    });
    const errorMessage = validateField(name, input);

    let obj = {};
    if (errorMessage == "") {
      obj = {
        required: false,
        highlight: false,
      };
    } else {
      obj = {
        required: true,
        highlight: true,
      };
    }

    setNewFormErrors(() => {
      // This `prevErrors` is the latest state from the store
      return {
        ...newFormErrors,
        [name]: obj,
      };
    });
  };

  //  calling API on load of page
  useEffect(() => {
    setNextBtnDisabled(true);
    const getAllData = async () => {
      // customerAPI.getSalesOrgs().then((result) => setSalesOrgOption(result.sort((firstVal, secondVal) => firstVal.localeCompare(secondVal))));
      resinAPI.getCharacterizedResin().then((result) => {
        setRecycledCharchterizedResinResponse(result);
        setRecycleCharacterizedResinOptions(
          result?.filter((element) => {
            if (
              requirements?.resinClass == DEFAULT_RESIN_CLASS_PO ||
              undefined === requirements?.resinClass
            ) {
              return !element.sub_class.includes("PET");
            } else {
              return element.sub_class.includes("PET");
            }
          })
        );
      });

      resinAPI.getVirginResin().then((result) => {
        setVirginCharachterizedResinResponse(result);
        setVirginCharacterizedResinOptions(
          result?.filter((element) => {
            if (
              requirements?.resinClass == DEFAULT_RESIN_CLASS_PO ||
              undefined === requirements?.resinClass
            ) {
              return !element.sub_class.includes("PET");
            } else {
              return element.sub_class.includes("PET");
            }
          })
        );
      });
    };
    /* Function call for the destroy function */
    getAllData();
    // if (requirements && requirements.salesOrg)
    //   setSalesOrg(requirements.salesOrg);
    // if (requirements && requirements.customer)
    //   setCustomer(requirements.customer);

    if (requirements?.resinClass == "PET") {
      setRequirements({ ...requirements, resinClass: "PET" });
      setSelectedResinValue("PET");
    } else {
      setRequirements({ ...requirements, resinClass: DEFAULT_RESIN_CLASS_PO });
      setSelectedResinValue(DEFAULT_RESIN_CLASS_PO);
    }
  }, []);

  //  state updates resin Requiremnets changes
  useEffect(() => {
    requirements &&
      setRecycleCharacterizedResin(requirements.selectedRecycledResin);
    requirements &&
      setVirginCharacterizedResin(requirements.selectedVirginResin);
  }, [requirements.resinRequirement]);

  //  when salesorg changed fetch the corresponding customer from API
  useEffect(() => {
    if (salesOrg) {
      setLoading(true);
      customerAPI
        .getCustomers(salesOrg)
        .then((result) => {
          let customerOptions = result.map((result) => ({
            sap_code: result.address.sap_code,
            name: result.address.name,
          }));
          setCustomerOptions(customerOptions);

          let customerFound = false;
          for (const value of customerOptions) {
            if (customer && customer.sap_code === value.sap_code) {
              setCustomer(value);
              customerFound = true;
              break;
            }
          }
          if (!customerFound) setCustomer(null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error while loading the sales org list", error);
        });
    }
  }, [salesOrg]);

  //  Characterized Resin for both select input state management
  const handleResinChange = (type, value) => {
    let dataToBeSaved = {};
    let stateObj = {
      required: true,
      highlight: false,
    };
    if (type == "recycled") {
      setRecycleCharacterizedResin(value);
      dataToBeSaved = {
        ...requirements,
        selectedRecycledResin: value,
        resinRequirement: {
          newResinvirgin: requirements.resinRequirement.newResinvirgin,
          newResinRecycled: {
            resinName: "",
            batchNumber: "",
            thickness: "",
            fileName: "",
            rtCurve: {},
            dilutionDetails: {
              recycledResinConc: "",
              virginResinConc: "",
            },
          },
        },
      };

      setRecycledDialogErrors(() => {
        // This `prevErrors` is the latest state from the store
        return {
          thickness: stateObj,
          resinName: stateObj,
          recycledResinConc: stateObj,
        };
      });
    } else if (type == "virgin") {
      setVirginCharacterizedResin(value);
      dataToBeSaved = {
        ...requirements,
        selectedVirginResin: value,
        selectedRecycledResin: "",
        resinRequirement: {
          newResinRecycled: requirements.resinRequirement.newResinRecycled,
          newResinvirgin: {
            resinName: "",
            batchNumber: "",
            thickness: "",
            fileName: "",
            rtCurve: {},
          },
        },
      };
      /*
        Code for filter the recycled charachterized resin according to the subclass 
        Set the setRecycleCharacterizedResinOptions from here 
      */

      if (value) {
        let definedSubClass = RESIN_CLASS_SUB_CLASS_MAPPING[value?.sub_class];
        setRecycleCharacterizedResinOptions(
          recycledCharchterizedResinResponse?.filter((element) => {
            if (undefined !== definedSubClass) {
              return element.sub_class.includes(definedSubClass);
            } else {
              if (requirements?.resinClass == DEFAULT_RESIN_CLASS_PO) {
                return element.sub_class.includes("PET");
              } else {
                return !element.sub_class.includes("PET");
              }
            }
          })
        );
      }

      setVirginDialogErrors(() => {
        // This `prevErrors` is the latest state from the store
        return {
          thickness: stateObj,
          resinName: stateObj,
        };
      });
    }
    setRequirements(dataToBeSaved);
    const errorMessage = validateField(type, value);
    let obj = {};
    if (errorMessage == "") {
      obj = {
        required: false,
        highlight: false,
      };
    } else {
      obj = {
        required: true,
        highlight: true,
      };
    }
    setNewFormErrors(() => {
      // This `prevErrors` is the latest state from the store
      return {
        ...newFormErrors,
        [type]: obj,
      };
    });
  };

  //  when delete of virgin resin states reset to empty
  let deleteNewResinVirginData = () => {
    setRequirements({
      ...requirements,
      resinRequirement: {
        newResinRecycled: requirements.resinRequirement.newResinRecycled,
        newResinvirgin: {
          resinName: "",
          batchNumber: "",
          thickness: "",
          fileName: "",
          rtCurve: {},
        },
      },
    });

    setVirginDialogErrors(() => {
      // This `prevErrors` is the latest state from the store
      return {
        ...virginDialogErrors,
        thickness: {
          required: true,
          highlight: false,
        },
        upload: {
          required: false,
          highlight: false,
        },
        resinName: {
          required: true,
          highlight: false,
        },
      };
    });

    /* reset next button to false */
    setNewFormErrors(() => {
      // This `prevErrors` is the latest state from the store
      return {
        ...newFormErrors,
        virgin: {
          required: true,
          highlight: false,
        },
      };
    });
  };

  //  when delete of Recycled date states reset to empty
  let deleteNewResinRecycledData = () => {
    setRequirements({
      ...requirements,
      resinRequirement: {
        newResinvirgin: requirements.resinRequirement.newResinvirgin,
        newResinRecycled: {
          resinName: "",
          batchNumber: "",
          thickness: "",
          rtCurve: {},
          fileName: "",
          dilutionDetails: {
            recycledResinConc: "",
            virginResinConc: "",
          },
        },
      },
    });

    setRecycledDialogErrors(() => {
      // This `prevErrors` is the latest state from the store
      return {
        ...recycledDialogErrors,
        thickness: {
          required: true,
          highlight: false,
        },
        upload: {
          required: false,
          highlight: false,
        },
        resinName: {
          required: true,
          highlight: false,
        },
        recycledResinConc: {
          required: true,
          highlight: false,
        },
      };
    });

    /* reset next button to false */
    setNewFormErrors(() => {
      // This `prevErrors` is the latest state from the store
      return {
        ...newFormErrors,
        recycled: {
          required: true,
          highlight: false,
        },
      };
    });
  };

  const handleRadioChange = (event) => {
    const newOption = event.target.value;
    setSelectedOption(newOption);
    requirements.requestNumber = "";
    setRequirements({ ...requirements });

    setNewFormErrors(() => {
      // This `prevErrors` is the latest state from the store
      return {
        ...newFormErrors,
        ["requestNumber"]: {
          required: true,
          highlight: false,
        },
      };
    });

    if (newOption === "tar") {
      setRequirements({
        ...requirements,
        ["requestType"]: newOption,
      });
      setMask("999999-99");
    } else {
      setMask("999999999999");
      setRequirements({
        ...requirements,
        ["requestType"]: newOption,
      });
    }
  };

  const validateField = (name, value) => {
    let errorMessage = "";
    let stateObj = {};
    switch (name) {
      case "thickness":
        // Validation for the 'name' field
        if (value.trim() === "") {
          errorMessage = "Thickness is required.";
        } else if (value < 0.1 || value > 5) {
          errorMessage = "Thickness should be greater than 0.1 and less than 5";
        } else {
          errorMessage = "";
        }
        break;

      case "ldr":
        // Validation for the 'email' field
        if (value.trim() === "") {
          errorMessage = "Let down Ratio is required.";
        } else if (value < 0.01 || value > 20) {
          errorMessage =
            "Let Down Ratio should be greater than 0.01 and less than 20";
        }
        break;

      case "requestNumber":
        // Validation for the 'password' field
        if (value.includes("-")) {
          let actualVal = value.replace(/[-_]/g, "");
          if (actualVal.length > 7) {
            errorMessage = "";
          } else {
            errorMessage = "tar";
          }
        } else if (value.includes("_") || value.length == 11) {
          let actualVal = value.replace(/[_]/g, "");
          if (actualVal.length == 12) {
            errorMessage = "";
          } else {
            errorMessage = "cadr";
          }
        } else {
          return "";
        }
        break;

      case "recycledResinConc":
        // Validation for the 'password' field
        if (value.trim() === "") {
          errorMessage = "Recycled resin is required.";
        } else if (value < 0 || value > 100) {
          errorMessage =
            "Recycled resin concentration should be 0 and less than 100";
        }
        setRequirements({
          ...requirements,
          recycledResinConc: value,
          virginResinConc:
            value != "" ? (100 - parseFloat(value)).toFixed(2) : 0,
        });
        break;

      case "tar":
        // Validation for the 'password' field
        if (value === null) {
          errorMessage = "Tar value is required";
        }
        break;

      case "cadr":
        // Validation for the 'password' field
        if (value === null) {
          errorMessage = "CADR value is required";
        }
        break;

      case "virgin":
        // Validation for the 'password' field
        if (value === null) {
          errorMessage = "Virgin resin value is required";
        }
        break;

      case "recycled":
        // Validation for the 'password' field
        if (value === null) {
          errorMessage = "Recycled resin value is required";
        }
        break;

      default:
    }
    return errorMessage;
  };

  return (
    <>
      {loading ? (
        <Box>
          <Loader className="download-overlay" message="" />
        </Box>
      ) : (
        <div></div>
      )}
      <Box>
        <Grid container spacing={3} sx={{ mt: 5, mb: 5 }}>
          <Grid xs={6}>
            <Grid xs={6}></Grid>
            <Grid xs={3}>
              <FormLabel
                component="legend"
                sx={{
                  fontWeight: "bold",
                  fontSize: "15px",
                  color: "#303c43",
                }}
              >
                Request Type
              </FormLabel>
              <Box>
                <RadioGroup
                  aria-label="Request type"
                  onChange={handleRadioChange}
                  value={selectedOption}
                >
                  <FormControlLabel
                    control={<Radio />}
                    label="TAR"
                    value="tar"
                    onChange={(e) => inputTextChange(e)}
                    name="requestType"
                  />
                  <FormControlLabel
                    control={<Radio />}
                    label="CADR"
                    value="cadr"
                    onChange={(e) => inputTextChange(e)}
                    name="requestType"
                  />
                </RadioGroup>
              </Box>
            </Grid>

            <Grid xs={6}></Grid>
            <Grid
              xs={3}
              className="font-22 font-weight-600 line-height-32  black-heading"
              sx={{ marginTop: "24px" }}
            >
              {" "}
              <MaskedTextField
                mask={mask}
                placeholder="eg. TAR 800000-25 / CADR 200000401112"
                name="requestNumber"
                text="text"
                heading="Request Number"
                value={requirements && requirements?.requestNumber}
                onChange={(e) => inputTextChange(e)}
                isError={newFormErrors?.requestNumber?.highlight}
                errorMessage={
                  newFormErrors?.requestNumber?.highlight
                    ? selectedOption == "tar"
                      ? "Required 8 digits"
                      : "Required 12 digits"
                    : ""
                }
              />
            </Grid>
            <Grid xs={6}></Grid>
            <Grid
              xs={6}
              className="font-22 font-weight-600 line-height-32  black-heading"
              sx={{ marginTop: "24px" }}
            >
              {" "}
              <ModifiedTextField
                name="remarks"
                heading={
                  <>
                    Remarks{" "}
                    <span
                      style={{
                        fontStyle: "Italic",
                        fontSize: "14px",
                        fontWeight: "normal",
                      }}
                    >
                      (optional)
                    </span>
                  </>
                }
                placeholder="Enter any additional details e.g. project, customer"
                type="text"
                value={requirements && requirements?.remarks}
                onChange={(e) => inputTextChange(e)}
              />
            </Grid>

            <Box
              className="font-22 font-weight-600 line-height-32  black-heading"
              sx={{ marginTop: "35px" }}
            >
              {" "}
              Customer Requirements{" "}
            </Box>
          </Grid>

          <Grid xs={6}></Grid>
          <Grid xs={3}>
            {" "}
            <ModifiedTextField
              heading="Thickness (mm)"
              name="thickness"
              placeholder="0.1-5"
              type="number"
              value={requirements && requirements.thickness}
              maxValue={5}
              minValue={0}
              onChange={(e) => inputChange(e, 5)}
              isError={newFormErrors?.thickness?.highlight}
              errorMessage={
                newFormErrors?.thickness?.highlight ? "0.1 to 5" : ""
              }
            />
          </Grid>

          <Grid xs={3}>
            {" "}
            <ModifiedTextField
              name="ldr"
              heading="Let Down Ratio (%)"
              placeholder="0.01-20"
              type="number"
              value={requirements && requirements.ldr}
              maxValue={20}
              minValue={0}
              onChange={(e) => inputChange(e, 20)}
              isError={newFormErrors?.ldr?.highlight}
              errorMessage={newFormErrors?.ldr?.highlight ? "0.01 to 20" : ""}
            />
          </Grid>

          <Grid xs={6}></Grid>

          <Grid xs={3}>
            {" "}
            <ModifiedTextField
              name="recycledResinConc"
              heading="Recycled Resin Conc. (%)"
              placeholder="0-100"
              type="number"
              value={requirements && requirements.recycledResinConc}
              onChange={(e) => inputChange(e, 100)}
              isError={newFormErrors?.recycledResinConc?.highlight}
              errorMessage={
                newFormErrors?.recycledResinConc?.highlight ? "0 to 100" : ""
              }
            />
          </Grid>
          <Grid xs={3}>
            {" "}
            <Stack spacing={2}>
              <Box className="font-16 font-weight-600 line-height-24">
                Virgin Resin Conc.
              </Box>
              <Box
                sx={{
                  color: "#303C43",
                  fontSize: "16px",
                  fontFamily: "Source Sans Pro",
                  fontWeight: "400",
                  lineHeight: "24px",
                  wordWrap: "break-word",
                }}
              >
                {requirements && requirements.virginResinConc
                  ? `${requirements.virginResinConc} %`
                  : "0 %"}
              </Box>
            </Stack>
          </Grid>
          <Grid xs={6}></Grid>

          <Grid xs={6}>
            {" "}
            <Box
              className="font-22 font-weight-600 line-height-32  black-heading"
              sx={{ marginTop: "24px" }}
            >
              Resin Requirements
            </Box>
          </Grid>
          <Grid xs={6}></Grid>
          <Grid xs={3}>
            {" "}
            <Box className="font-16 font-weight-600 line-height-24">
              {" "}
              Resin Type{" "}
            </Box>
            <Select
              name="resinClass"
              className="SelctBoxMui"
              placeholder="Select"
              IconComponent={KeyboardArrowDownIcon}
              displayEmpty
              onChange={handleSelectedResinClass}
              value={selectedResinValue}
              sx={{
                fontFamily: "Source Sans Pro",
                fontSize: "14px !important",
                fontWeight: "400",
                height: "36px",
                minWidth: "75px",
                width: "100%",
                mt: "8px",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderRadius: "0px !important",
                },
                "& .MuiSvgIcon-root": { color: "#3793D5", marginRight: "2px" },
              }}
            >
              {RESIN_CLASS.map((e) => {
                return (
                  <MenuItem
                    sx={{
                      borderBottomColor: "#C7C9C7",
                    }}
                    key={e}
                    value={e}
                  >
                    {" "}
                    {e}
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>
          <Grid xs={9}></Grid>

          <Grid xs={6}>
            {" "}
            <Box>
              <RadioField
                heading="Virgin Resin"
                options={["Characterized Resin", "New Resin"]}
                name="virginResin"
                value={selectedVirginResin}
                sx={{
                  fontWeight: "400",
                  fontSize: "15px",
                  lineHeight: "0.5",
                  letterSpacing: "0.00938em",
                }}
                checked={selectedVirginResin}
                onChange={(event, value) => {
                  handleChange("virgin", value);
                }}
              />
            </Box>
          </Grid>
          <Grid xs={6}></Grid>
          {requirements && requirements.virginResin == "Characterized Resin" ? (
            <>
              <Grid xs={6} sx={paddingZero}>
                {" "}
                <SearchAutocomplete
                  val={{
                    heading: "Resin",
                    options: virginCharacterizedResinOptions,
                  }}
                  value={virginCharacterizedResin}
                  isError={newFormErrors?.virgin?.highlight}
                  onChange={(event, value) => {
                    handleResinChange("virgin", value);
                  }}
                />
                {newFormErrors?.virgin?.highlight && (
                  <FormHelperText sx={{ color: "#d32f2f" }}>
                    Required Field
                  </FormHelperText>
                )}
              </Grid>
              <Grid xs={6}></Grid>
            </>
          ) : (
            ""
          )}

          {requirements && requirements.virginResin == "New Resin" ? (
            <>
              <Grid xs={8} container sx={paddingZero}>
                <Grid xs={2.5}>
                  <Button
                    onClick={handleClickOpenVirginResin}
                    sx={{
                      color: "#385DAE",
                      fontSize: "16px",
                      textTransform: "none",
                      fontFamily: "Source Sans Pro",
                    }}
                    startIcon={<UploadFileIcon />}
                  >
                    Upload File
                  </Button>
                </Grid>
                {requirements.resinRequirement?.newResinvirgin &&
                  requirements.resinRequirement.newResinvirgin.fileName && (
                    <>
                      <Grid xs={8.5} sx={{ alignContent: "center" }}>
                        <Box>
                          {
                            requirements.resinRequirement.newResinvirgin
                              .fileName
                          }
                        </Box>
                      </Grid>
                      <Grid xs={1}>
                        <CloseIcon
                          sx={{
                            color: "darkgrey",
                            cursor: "pointer",
                            position: "relative",
                            top: "6px",
                            paddingLeft: "6px",
                          }}
                          onClick={() => {
                            deleteNewResinVirginData();
                          }}
                        />
                      </Grid>
                    </>
                  )}
              </Grid>
            </>
          ) : (
            ""
          )}
          <Grid xs={6} sx={{ mt: 1 }}>
            {/* <Box
              sx={{
                fontWeight: "700",
                padding: "4px",
              }}
            >
              Recycled Resin
            </Box> */}
            <Box
            // sx={{
            //   // Conditionally apply a red border when `error` is true
            //   border: true ? "1px solid red" : "1px solid transparent",
            //   borderRadius: "8px",
            //   padding: "2px",
            // }}
            >
              <RadioField
                heading="Recycled Resin"
                options={["Characterized Resin", "New Resin"]}
                name={"recycledResin"}
                sx={{
                  fontWeight: "400",
                  fontSize: "15px",
                  lineHeight: "0.5",
                  letterSpacing: "0.00938em",
                }}
              />
            </Box>
          </Grid>
          <Grid xs={6}></Grid>

          {requirements &&
          requirements.recycledResin == "Characterized Resin" ? (
            <>
              <Grid xs={6} sx={paddingZero}>
                {" "}
                <SearchAutocomplete
                  val={{
                    heading: "Resin",
                    options: recycleCharacterizedResinOptions,
                  }}
                  value={recycleCharacterizedResin}
                  isError={newFormErrors?.recycled?.highlight}
                  onChange={(event, value) => {
                    handleResinChange("recycled", value);
                  }}
                />
                {newFormErrors?.recycled?.highlight && (
                  <FormHelperText sx={{ color: "#d32f2f" }}>
                    Required Field
                  </FormHelperText>
                )}
              </Grid>
              <Grid xs={6}></Grid>
            </>
          ) : (
            ""
          )}

          {requirements && requirements.recycledResin == "New Resin" ? (
            <>
              <Grid xs={8} container sx={paddingZero}>
                <Grid xs={2.5}>
                  <Button
                    onClick={handleClickOpenRecycleResin}
                    sx={{
                      color: "#385DAE",
                      fontSize: "16px",
                      textTransform: "none",
                      fontFamily: "Source Sans Pro",
                    }}
                    startIcon={<UploadFileIcon />}
                  >
                    Upload File
                  </Button>
                </Grid>
                {requirements.resinRequirement?.newResinRecycled &&
                  requirements.resinRequirement.newResinRecycled.fileName && (
                    <>
                      <Grid xs={8.5} sx={{ alignContent: "center" }}>
                        {" "}
                        <Box>
                          {
                            requirements.resinRequirement.newResinRecycled
                              .fileName
                          }
                        </Box>
                      </Grid>
                      <Grid xs={1}>
                        <CloseIcon
                          sx={{
                            color: "darkgrey",
                            cursor: "pointer",
                            position: "relative",
                            top: "6px",
                            paddingLeft: "6px",
                          }}
                          onClick={() => {
                            deleteNewResinRecycledData();
                          }}
                        />
                      </Grid>
                    </>
                  )}
              </Grid>
              <Grid xs={6}></Grid>
            </>
          ) : (
            ""
          )}
        </Grid>

        <RecycledResinDialog
          open={openRecycleResin}
          setOpen={setOpenRecyleResin}
        />

        <VirginResinDialog
          open={openVirginResin}
          setOpen={setOpenVirginResin}
        />
      </Box>
    </>
  );
};
